import { APP_BASE_HREF } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  signal
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { ConsoleService } from '@app/_core/services/console.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { ConfigService } from '@app/config.services';
import { TaskMenuComponent } from '@app/pages/common/task-menu/task-menu.component';
import { MainControllerComponent } from '@app/pages/queue/dialer/MainController.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { fromEvent, lastValueFrom, merge, Subscription, timer } from 'rxjs';
import { EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { DialerService } from '@app/_core/services/dialer.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy, OnChanges {
  showInternetSpeed: boolean = environment.showInternetSpeed;
  modifiedQueueData: any;
  modalRef?: BsModalRef;
  clientAbbreviation = Utils.fetch('clientAbbreviation');
  queuesRes: any;
  private subscription = new Subscription();
  // filteredSections: any = [];
  filteredQueueSections: any;
  @Input() IsDisableHeader: boolean;
  IsDisablemenu: boolean = false;
  IsMainMenuClicked: boolean = false;
  QueueInfoDetail: any;
  isButtonDisable: boolean = false;
  loginDate:Date = new Date();
  internetSpeed: string = '--';
  isSpeedLoading: boolean = true;
  queueType: any;
  isPredictiveopened = signal(false); // line 57
	private sub!: Subscription;
  constructor(
    private securityService: SecurityService,
    private consoleService: ConsoleService,
    private router: Router,
    private appService: AppService,
    private tmQueueService: TmQueueService,
    private queueService: QueuesService,
    private modalService: BsModalService,
    private HeaderComponent: HeaderComponent,
    private cdr: ChangeDetectorRef,
    private mainController: MainControllerComponent,
    private configService: ConfigService,
    private dialerService: DialerService,
    private webStorageService: WebStorageService,
    private flexStore: FlexibleStoreService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {
    this.queueService.notifyObservableTaskMenu.subscribe(data => {
      //console.log('data', data);
      this.selectedListIndex = 0;
      this.IsMainMenuClicked = true;
      if (data.menuName == 'Inbound') {
        this.selectMenu(0, data.menuName);
      } else if (data.menuName == 'Outbound') {
        this.selectMenu(1, data.menuName);
      } else if (data.menuName == 'Search') {
        this.selectMenu(2, data.menuName);
      } else if (data.menuName == 'Email') {
        this.selectMenu(0, data.menuName);
      }
    });

    this.queueService.VoiceMailNav.subscribe(res => {
      if (res) {
        this.selectedListMenu = [];
        this.menus = [];
        this.subMenus = [];
      }
    });
    router.events.forEach(event => {
      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate') {
          this.highlightCurrentMenufromUrl(event.url);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('ENV CHECK →',environment.environmentName,'| production =',environment.production);
    //console.log('Changes:', changes);
  }

  
 ngOnDestroy(): void {
  // console.log('MenuComponent destroyed!');
  this.subscription.unsubscribe();

  this.sub?.unsubscribe();
}

  selectedListIndex: any;
  selectedMenuIndex: any;
  selectedSubMenuIndex: any;

  listMenu1: any;
  menus: any = [];
  subMenus: any = [];
  isFirstQueues: boolean = false;
  isFirstPerformance: boolean = false;

  listMenu: any;
  listMenuQueue: any = [];
  listMenuPerformance: any;

  //menuList: any;
  //subMenuList: any;
  //superSubMenuList: any;

  selectedListMenu: any = [];
  selectedMenuList: any = [];
  selectedSubMenuList: any = [];

  hasAuditSurvey: any = null;
  consoleSections: any = [];
  queueSections: any = [];
  isAuditor: boolean = false;
  isManager: boolean = false;
  isIVRManager: boolean = false;
  isStaffer: boolean = false;
  isCampaigner: boolean = false;
  isReporter: boolean = false;
  isTM: boolean = false;
  isSoftphoneOnly: boolean = false;
  isTwilio: boolean = false;
  aiAuditEnabled: boolean = false;
  isKnowledge: boolean = false;

  /**
   * Measures download speed in Mbps using Cloudflare's speed endpoint.
   * Replaces ng-speed-test to eliminate its hardcoded httpbin.org connectivity probe
   * which caused spurious 500 errors in production monitoring.
   */
  private measureMbps(): Promise<number> {
    const url = `https://speed.cloudflare.com/__down?bytes=5000000&_=${Date.now()}`;
    const fileSizeBytes = 5_000_000;
    const startTime = performance.now();
    return fetch(url, { cache: 'no-store' })
      .then(res => res.arrayBuffer())
      .then(() => {
        const durationSeconds = (performance.now() - startTime) / 1000;
        return (fileSizeBytes * 8) / durationSeconds / 1_000_000; // Mbps
      });
  }

  async ngOnInit() {
    //console.log('MenuComponent ngOnInit');
    // this.appService.isQueueDisableMenu.subscribe(res => {
    //   console.log(res);
    //   if (res) {
    //     this.IsDisablemenu = false;
    //   } 
    // });
    //console.log(this.modifiedQueueData);
    this.aiAuditEnabled = this.appService.getAIAuditEnabled();
    setInterval(() => {
      this.loginDate = new Date();
      }, 1000);

    if (this.showInternetSpeed) {
      const runSpeedTest = () => {
        this.isSpeedLoading = true;
        this.cdr.detectChanges();
        this.measureMbps()
          .then(speed => {
            this.internetSpeed = speed.toFixed(1);
            this.isSpeedLoading = false;
            this.cdr.detectChanges();
          })
          .catch(() => {
            this.internetSpeed = '--';
            this.isSpeedLoading = false;
            this.cdr.detectChanges();
          });
      };

      this.subscription.add(
        merge(
          timer(0, 60000),
          fromEvent(window, 'online')
        ).subscribe(() => runSpeedTest())
      );
      this.sub = this.dialerService.isPredictiveModalOpen$.subscribe(isOpen => {
        this.isPredictiveopened.set(isOpen);
      });
    }
    this.isAuditor = this.securityService.validateGrant('AuditAgents');
    this.isManager = this.securityService.validateGrant('ManageAgents');
    this.isIVRManager = this.securityService.validateGrant('ManageIVR');
    this.isStaffer = this.securityService.validateGrant('ManageAssignments');
    this.isCampaigner = this.securityService.validateGrant('ManageCampaigns');
    this.isTM = this.securityService.validateGrant('TM');
    this.isSoftphoneOnly = this.securityService.validateGrant('SoftphoneOnly');
    this.isTwilio = this.securityService.validateGrant('Twilio');
    this.isKnowledge = this.securityService.validateGrant('TM');
    this.subscription.add(
      this.appService.currentMenu.subscribe((val: any) => {
        if (val != null) {
          this.highlightCurrentMenufromUrl(val.action);
          this.IsMainMenuClicked = false;
        }
      })
    );

    this.sub = this.dialerService.isPredictiveModalOpen$.subscribe(isOpen => {
      this.isPredictiveopened.set(isOpen);
    });

    if (!(this.isAuditor || this.isManager || this.isStaffer)) {
      if (this.isTM) {
        this.router.navigate([this.clientAbbreviation + '/Queue']);
      }
      //this.router.navigate(['/']);
    } else {
      // cacheKey = cls.Security().user().UserID + location.hash.split('/Console')[0] + '/Console';
      // if (im.QueueSelectorController.instance() != null)
      //     im.QueueSelectorController.instance().clear();
      // dataService = im.DataService.instance(true);
      // consoleService = im.AuditorService.instance(true);
      //var self = cls;
      //console.log(this.hasAuditSurvey);

      await this.checkAuditSurveyExperience();
      //console.log(this.hasAuditSurvey);

      const stafferSections = [
        { action: 'Queues', label: 'Queues', isselected: false, isdisabled: false, children: [] },
        { action: 'Skills', label: 'Skills', isselected: false, isdisabled: false, children: [] },
        { action: 'Groups', label: 'Groups', isselected: false, isdisabled: false, children: [] },
      ];

      const agentSections = [
        {
          action: 'Agents',
          label: 'Agents',
          isselected: false,
          isdisabled: false,
          children: [
            {
              action: 'LiveStatuses',
              label: 'Live Statuses',
              isselected: false,
              isdisabled: false,
              children: [],
            },
            {
              action: 'HistoricalMetrics',
              label: 'Historical Metrics',
              isselected: false,
              isdisabled: false,
              children: [],
            },
          ],
        },
      ];

      const managerSections = [
        {
          action: 'Voicemails',
          label: 'Voicemails',
          isselected: false,
          isdisabled: false,
          children: [],
        },
      ];

      const campaignerSections = [
        {
          action: 'Campaigns',
          label: 'Campaigns',
          isselected: false,
          isdisabled: false,
          children: [],
        },
      ];

      const ivrSections = [
        {
          action: 'IVR',
          label: 'IVR Prompts',
          isselected: false,
          isdisabled: false,
          children: [],
        },
      ];
      const knowledgeSections = [
        {
          action: 'Knowledge-docs',
          label: 'Knowledge Docs',
          isselected: false,
          isdisabled: false,
          children: [],
        },
      ];
  
      const showAIMenus = environment.environmentName === 'dev' || environment.environmentName === 'STAGE';
      const aiMenus = showAIMenus
      ? [
          {
            action: 'AIInteractions',
            label: 'AI Interactions',
            isselected: false,
            isdisabled: false,
            children: [],
          },
          {
            type: 'group',
            action: 'AIAudits',
            label: 'AI Audits',
            isselected: false,
            isdisabled: false,
            children: [],
          }
        ]
      : [];
      let auditorSections = [
        {
          action: 'Auditing',
          label: 'Auditing',
          isselected: false,
          isdisabled: false,
          children: [
            //...aiMenus,
            {
              action: 'Interactions',
              label: 'Interactions',
              isselected: false,
              isdisabled: false,
              children: [],
            },
                {
                      type: 'group',
                      action: 'Audits',
                      label: 'Audits',
                      isselected: false,
                      isdisabled: false,
                      children: [],
                    }
          ],
        },
      ];

      // let auditorSections = [
      //   {
      //     action: 'Auditing',
      //     label: 'Auditing',
      //     isselected: false,
      //     isdisabled: false,
      //     children:  [
      //       {
      //         action: 'AIInteractions',
      //         label: 'AI Interactions',
      //         isselected: false,
      //         isdisabled: false,
      //         children: [],
      //       },
      //       {
      //         type: 'group',
      //         action: 'AIAudits',
      //         label: 'AI Audits',
      //         isselected: false,
      //         isdisabled: false,
      //         children: [],
      //       },
      //       {
      //         action: 'Interactions',
      //         label: 'Interactions',
      //         isselected: false,
      //         isdisabled: false,
      //         children: [],
      //       },
      //       {
      //         type: 'group',
      //         action: 'Audits',
      //         label: 'Audits',
      //         isselected: false,
      //         isdisabled: false,
      //         children: [],
      //       }
      //     ],
      //   },
      // ];

      const nonauditorSections = [
        {
          action: 'Interactions',
          label: 'Review Interactions',
          isselected: false,
          isdisabled: false,
          children: [],
        },
      ];

      if (this.isStaffer) this.consoleSections = this.consoleSections.concat(stafferSections);
      if (this.isStaffer || this.isManager || this.isAuditor)
        this.consoleSections = this.consoleSections.concat(agentSections);
      if (this.isStaffer || this.isManager) this.consoleSections = this.consoleSections.concat(managerSections);
      if (this.isCampaigner) this.consoleSections = this.consoleSections.concat(campaignerSections);
      if (this.isIVRManager) this.consoleSections = this.consoleSections.concat(ivrSections);
      if (this.isAuditor && this.hasAuditSurvey) this.consoleSections = this.consoleSections.concat(auditorSections);
      else if (this.isAuditor || this.isManager) this.consoleSections = this.consoleSections.concat(nonauditorSections);
      //if (this.isKnowledge) this.consoleSections = this.consoleSections.concat(knowledgeSections);

      if (!this.hasAuditSurvey && this.isAuditor) {
        //alert("<strong>Warning</strong><br />No Audit Survey Experience has been configured. Auditing features will be disabled until completed.");
      }
    }

    this.queueSections = [
      { label: 'Blended', action: 'Blended', isselected: false, isdisabled: false, children: [] },
      { label: 'Inbound', action: 'Inbound', isselected: false, isdisabled: false, children: [] },
      {
        label: 'Outbound',
        action: 'Outbound',
        isselected: false,
        isdisabled: false,
        children: [],
      },
      { label: 'Search', action: 'Search', isselected: false, isdisabled: false, children: [] },
      {
        label: 'TextChat',
        action: 'TextChat',
        isselected: false,
        isdisabled: true,
        children: [],
      },
      {
        label: 'VideoChat',
        action: 'TextChat',
        isselected: false,
        isdisabled: true,
        children: [],
      },
      ...(environment.enableEmailQueue ? [{
        label: 'Email',
        action: 'Email',
        isselected: false,
        isdisabled: true,
        children: [],
      }] : []),
    ];
    //{ label: 'Text/Video Chat', action: "TextVideoChat", isselected: false, children: [] },
    //{ label: 'Email Queue', action: "EmailQueue", isselected: false, children: [{ label: 'Check Issue', isselected: false, action: "CheckIssue" }, { label: 'Mailroom', isselected: false, action: "Mailroom" }, { label: 'Provider Intake', isselected: false, action: "ProviderIntake" }] }];

    await this.getQueuesMap(null);
    this.drawMenuLink();
    this.highlightCurrentMenufromUrl(this.router.url);
    this.HeaderComponent.changeUserStatusHeader();
  }

  async getQueuesMap(modifiedData) {
    //console.log('MenuComponent getQueuesMap');
    if (modifiedData && modifiedData != undefined) {
      this.queuesRes = modifiedData;
    } else {
      // if (!this.tmQueueService.getisTopMenuQueueSelected()) {
      const data: any = await lastValueFrom(this.tmQueueService.getQueues());
      this.queuesRes = data.Response.Data;
      //}
    }
    //if (!this.tmQueueService.getisTopMenuQueueSelected()) {
    const filteredSections = [];
    this.queuesRes.forEach(element => {
      let tempQueues = this.queueSections.filter(i => i.label == element.Type && i !== undefined && i !== null)[0];
      if (tempQueues)
        filteredSections.push(tempQueues);
    });

    //console.log('filteredSections', filteredSections);
    const ids = filteredSections.map(({ label }) => label);
    this.filteredQueueSections = filteredSections.filter(({ label }, index) => !ids.includes(label, index + 1));
    //console.log('filteredQueueSections', this.filteredQueueSections);
    if (environment.enableEmailQueue) {
      this.filteredQueueSections.push({
        label: 'Email',
        action: 'Email',
        isselected: false,
        isdisabled: false,
        children: [],
      });
    }
    this.drawMenuLink();
    //}
  }

  highlightCurrentMenufromUrl(url: string) {
    //console.log('MenuComponent highlightCurrentMenufromUrl', url);

    // SECURITY: Sanitize the URL before splitting to prevent user-controlled input from
    // influencing the loop bound (SAST: Loop Bound Injection / Unsafe Iteration).
    // 1. Strip query string — everything from '?' onward is irrelevant for routing.
    // 2. Cap urlArray to 3 segments (listMenu / menu / subMenu) — the maximum depth the
    //    loop ever accesses — so urlArray.length is always a trusted constant, not user-driven.
    const MAX_URL_DEPTH = 3;
    const sanitizedUrl = url.split('?')[0];
    let urlArray: any = sanitizedUrl.split('/').slice(0, MAX_URL_DEPTH + 2); // +2 accounts for leading empty segments before splice
    //urlArray.shift();
    if (urlArray.length > 2) {
      urlArray.splice(0, 2);
    }
    // Enforce the depth cap after the leading-segment splice
    if (urlArray.length > MAX_URL_DEPTH) {
      urlArray = urlArray.slice(0, MAX_URL_DEPTH);
    }
      if (urlArray[1] == 'Queue' || urlArray[0] == 'Queue' || (urlArray[1] == 'Queues' && this.filteredQueueSections.length == 0 ) ||  urlArray[0] == 'Inbound' || urlArray[0] == 'Email') {
      urlArray = ['Queue'];
    }

    // if (urlArray[0] == 'Voicemails') {
    //   urlArray = ['Console'];
    //   this.isFirstQueues = true;
    //   this.menus = [];
    //   this.subMenus = [];
    // }
    if (urlArray[1] == 'Performance') {
      this.IsDisablemenu = false
    }
    if (!this.isFirstPerformance && urlArray[1] == 'Performance') {
      urlArray = ['Performance'];
      this.isFirstPerformance = true;
    } else {
      this.isFirstPerformance = false;
    }
    if (!this.isFirstQueues && (urlArray[0] == 'Queues' || urlArray[1] == 'Console')) {
      if (this.isStaffer) {
        urlArray = ['Console', 'Queues'];
      }
      if ((this.isManager || this.isAuditor) && !this.isStaffer) {
        urlArray = ['Console', 'Agents', 'Live Statuses'];
      }
      this.isFirstQueues = true;
      this.IsDisablemenu = false
    } else {
      this.isFirstQueues = false;
      // this.IsDisablemenu = false
    }

    // console.log('urlArray', urlArray);
    // if (urlArray[0] != 'Queue') {
    // this.IsDisablemenu = false
    // }else  if (urlArray[0] == 'Queue' && this.filteredQueueSections.length == 1 && !(this.isStaffer || this.isManager || this.isAuditor)){
    //   this.IsDisablemenu = true
    // }

    if (urlArray[0] != 'Queue' && this.filteredQueueSections.length == 1 && (this.isStaffer || this.isManager || this.isAuditor)) {
      this.IsDisablemenu = false
    }

    if (urlArray[0] == 'Queue' && this.filteredQueueSections.length == 1 && !(this.isStaffer || this.isManager || this.isAuditor)) {
      this.IsDisablemenu = true
    }

    if (urlArray[0] != 'Queue') {
      if (urlArray.length > 0) {
        // SECURITY: Loop bound uses the trusted constant MAX_URL_DEPTH (not urlArray.length)
        // to prevent user-controlled URL from influencing iteration count (SAST: Loop Bound Injection).
        for (let i = 0; i < MAX_URL_DEPTH; i++) {
          if (urlArray[i] === undefined) break;
          if (i == 0) {
            const index = this.listMenu.findIndex((object: any) => {
              return object.action === this.clientAbbreviation + '/' + urlArray[i];
            });
            if (index != -1) this.selectLink(index);
          }
          if (i == 1) {
            const index = this.listMenu[this.selectedListIndex].children.findIndex((object: any) => {
              return object.action === urlArray[i];
            });
            if (index != -1) this.selectMenu(index, null);
          }
          if (i == 2) {
            const index = this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].children.findIndex(
              (object: any) => {
                return object.action === urlArray[i];
              }
            );
            if (index != -1) this.selectSubMenu(index);
          }
        }
      }
    } else if (
      urlArray[0] == 'Queue' &&
      !this.tmQueueService.getisTopMenuQueueSelected() &&
      !this.tmQueueService.getisQueueTaskMenuLoaded()
    ) {
      // console.log('false')
      this.selectQueueLink(0); //it will load initially
    }
  }

  selectQueueLink(i: number) {
    // console.log('MenuComponent selectQueueLink');
    // this.router.navigateByUrl('/' + this.listMenu[i].action);
    this.doOnInit(false);
  }

  drawMenuLink() {
    //console.log('MenuComponent drawMenuLink');
    this.isReporter = this.securityService.validateGrant('Reporting');
    this.listMenu = [
      {
        label: 'Queue',
        action: this.clientAbbreviation + '/Queue',
        imgpath: `${this.baseHref}/assets/images/icon-queue.svg`,
        isselected: false,
        children: this.filteredQueueSections,
      },
      {
        label: 'Console',
        action: this.clientAbbreviation + '/Console',
        imgpath: `${this.baseHref}/assets/images/icon-console.svg`,
        isselected: false,
        children: this.consoleSections,
      },
      {
        label: 'Performance',
        action: this.clientAbbreviation + '/Performance',
        imgpath: `${this.baseHref}/assets/images/icon-performance.svg`,
        isselected: false,
        children: [],
      },
      {
        label: 'Reporting Dashboard',
        action: this.goToDashboard(),
        //action: this.clientAbbreviation + '/ReportingDashboard',
        imgpath: `${this.baseHref}/assets/images/icon-queue.svg`,
        isselected: false,
        children: [],
      },
    ];
    if (this.filteredQueueSections.length == 0 && this.isTM && !(this.isAuditor || this.isManager || this.isStaffer)) {
      this.listMenu = []
    } else if (this.filteredQueueSections.length > 0 && this.isTM && !(this.isAuditor || this.isManager || this.isStaffer) && !this.isReporter) {
      this.listMenu = this.listMenu.filter(item => item.label === 'Queue' || item.label === 'Performance'
      );
    } else if (this.filteredQueueSections.length == 0 && this.isTM && (this.isAuditor || this.isManager || this.isStaffer) && !this.isReporter) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Console'
      );
    } else if (this.filteredQueueSections.length == 0 && this.isTM && (this.isAuditor || this.isManager || this.isStaffer) && this.isReporter) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Console' || item.label === 'Reporting Dashboard'
      );
    }
    else if (this.filteredQueueSections.length > 0 && this.isTM && !(this.isAuditor || this.isManager || this.isStaffer) && this.isReporter) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Queue' || item.label === 'Performance' || item.label === 'Reporting Dashboard'
      );
    }
    else if (this.filteredQueueSections.length > 0 && this.isTM && (this.isAuditor || this.isManager || this.isStaffer) && this.isReporter) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Queue' || item.label === 'Console' || item.label === 'Performance' || item.label === 'Reporting Dashboard'
      );
    }
    else if (this.filteredQueueSections.length > 0 && this.isTM && (this.isAuditor || this.isManager || this.isStaffer) && !this.isReporter) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Queue' || item.label === 'Console' || item.label === 'Performance'
      );
    }

    else if (this.filteredQueueSections.length > 0 && this.isTM && this.isAuditor) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Queue' || item.label === 'Console' || item.label === 'Performance'
      );
    } else if (this.filteredQueueSections.length > 0 && this.isTM && this.isIVRManager) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Queue' || item.label === 'Console' || item.label === 'Performance'
      );
    } else if (this.filteredQueueSections.length > 0 && this.isTM && this.isStaffer) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Queue' || item.label === 'Console' || item.label === 'Performance'
      );
    } else if (this.filteredQueueSections.length > 0 && this.isTM && this.isManager) {
      this.listMenu = this.listMenu.filter(
        item => item.label === 'Queue' || item.label === 'Console' || item.label === 'Performance'
      );
    }

    //  console.log(this.listMenu)
    // this.isReporter = this.securityService.validateGrant('Reporting');
    // if (this.isReporter ) {
    //   const reportTab = {
    //     label: 'Reporting Dashboard',
    //     action: 'https://dashboard.stage.cts-connect.com/',
    //     //action: this.clientAbbreviation + '/ReportingDashboard',
    //     imgpath: `${this.baseHref}/assets/images/icon-queue.svg`,
    //     isselected: false,
    //     children: [],
    //   }

    // if(this.listMenu.filter(item => item.label  != 'Reporting Dashboard')){
    //   this.listMenu.push(reportTab);
    // }
    //   // this.listMenu.forEach(element => {
    //   //   if(element.label != 'Reporting Dashboard'){
    //   //      this.listMenu =  this.listMenu.concat(reportTab);
    //   //   }
    //   // });
    // }

    //console.log(this.listMenu);
    if (this.listMenu[1]?.children) {
      sessionStorage.setItem('consoleChildren', JSON.stringify(this.listMenu[1].children));
    }
  }

    goToDashboard(): string {
    return this.webStorageService.getItemFromSessionStorage('loginParams')?.DashboardURL
  }

  clearSelectedMenus() {
    // console.log('MenuComponent clearSelectedMenus');
    this.listMenu?.forEach((list: any) => {
      list.isselected = false;
      const menuName = list.label;
      if (list.children && list.children.length > 0) {
        list.children.forEach((menu: any) => {
          if ((menu.label === 'Inbound' || menu.label === 'Outbound' || menu.label === 'Search' || menu.label === 'Email') && !this.IsMainMenuClicked) {
            // console.log("onclick queue menus");
          } else {
            menu.isselected = false;
          }
          if (menuName == 'Queue') {
            //menu.isdisabled = true;
            this.resetSubMenu(menu, true);
          } else {
            menu.isdisabled = false;
            this.resetSubMenu(menu, false);
          }
        });
      }
    });
  }

  resetSubMenu(menu: any, flag: boolean) {
    // console.log('MenuComponent resetSubMenu');
    if (menu.children && menu.children.length > 0) {
      menu.children.forEach((submenu: any) => {
        submenu.isselected = false;
        submenu.isdisabled = flag;
      });
    }
  }

  goMainLink(link: any) {
    this.IsMainMenuClicked = true;
    // console.log('MenuComponent goMainLink');
    if (link.label == 'Reporting Dashboard') {
      window.open(link.action);
      return;
    }
    this.appService.setisMenulinkClicked(true);
    // if(this.filteredQueueSections.length == 1 && link.label == 'Queue' ){
    //   this.listMenu[this.selectedListIndex].isselected = false;
    //   this.IsDisablemenu = true;
    //   this.getQueues();
    // }else{
    //   this.listMenu[this.selectedListIndex].isselected = true;
    //   this.IsDisablemenu = false
    // }
    var isBlendedAvailable = link.children.find(user => user.label === 'Blended');
    if (link.label == 'Queue') {
      this.isButtonDisable = true

      // this.queueService.setTaskMenuAccordian('Inbound');
      this.queueService.setTaskMenuAccordian((isBlendedAvailable ? 'Blended' : 'Inbound'));
      this.tmQueueService.setisTopMenuQueueSelected(true);
      this.tmQueueService.setisQueueTaskMenuLoaded(false);
      this.doOnInit(true); //it will call when main menu link clicked
      if (this.filteredQueueSections.length == 1) {
        this.IsDisablemenu = true;
      } else if (this.filteredQueueSections.length != 1) {
        this.IsDisablemenu = false;
      }

    }


    // this.appService.setCurrentMenu(null);



    this.modifiedQueueData = this.appService.getmodifiedQueueData();

    // console.log(this.modifiedQueueData);

    if (this.modifiedQueueData) {
      this.getQueuesMap(this.modifiedQueueData);
    }

    // console.log('link', link);

    this.highlightCurrentMenufromUrl(link.action);
    if (link.label == 'Console') {
      this.appService.setUserStatus(12, null);
      this.queueService.setTaskMenuAccordian((isBlendedAvailable ? 'Blended' : 'Inbound'));
      //this.doOnInit();
      this.IsDisablemenu = false;
      this.webStorageService.setItemInSessionStorage('previousUserStatus', 12);
    }
    else if (link.label == 'Performance') {
      this.appService.setUserStatus(10, null);
      this.appService.setSoftPhoneStatus('Ready');
      this.queueService.setTaskMenuAccordian((isBlendedAvailable ? 'Blended' : 'Inbound'));
      //this.doOnInit();
      this.IsDisablemenu = false;
      this.webStorageService.setItemInSessionStorage('previousUserStatus', 10);
    }






  }

  selectLink(i: number) {
    // console.log('MenuComponent selectLink');
    //test
    // console.log('this.listMenu[i]', this.listMenu[i]);
    if (this.listMenu[i].label != 'Queue') {
      this.clearSelectedMenus();
    }
    if (this.listMenu[i].children && this.listMenu[i].children.length > 0) {
      //Handle the Queue selection
      if (this.listMenu[i].label === 'Queue') {
        if (this.selectedListIndex == 0 && this.selectedMenuIndex == null) {
          //On load setting up menu and submenu
          this.listMenu[this.selectedListIndex].isselected = true;
          this.listMenu[this.selectedListIndex].children[0].isselected = true;
          this.listMenu[this.selectedListIndex].children[0].isdisabled = false;
          this.selectedListIndex = i;
          this.appService.setSelectedQueueName('Manager Console');
        } else {
          //On switch of other tab to queue tab for retaining selected menu and submenu.
          this.listMenu[this.selectedListIndex].isselected = true;
          if (this.selectedMenuIndex != null) {
            this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].isselected = true;
            this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].isdisabled = false;
          }
        }
      } else {
        if (!this.isStaffer && !this.isManager) {
          this.listMenu[i].isselected = true;
          this.listMenu[i].children[0].isselected = true;
          this.listMenu[i].children[0].isdisabled = false;
          this.selectedListIndex = i;
          this.appService.setSelectedQueueName('Auditor Console');
        } else {
          this.listMenu[i].isselected = true;
          this.listMenu[i].children[0].isselected = true;
          this.listMenu[i].children[0].isdisabled = false;
          this.selectedListIndex = i;
          this.appService.setSelectedQueueName('Manager Console');
        }
      }
      // console.log(this.listMenu[i]);
      this.subMenus = [];
    } else {
      if (!this.isStaffer && !this.isManager) {
        this.listMenu[i].isselected = true;
        this.selectedMenuIndex = null;
        this.selectedListIndex = i;
        //  alert(this.listMenu[i].action)

        this.navigateTo(this.listMenu[i].action);
        this.menus = [];
        this.subMenus = [];
        this.appService.setSelectedQueueName('Auditor Console');
      } else {
        this.listMenu[i].isselected = true;
        this.selectedMenuIndex = null;
        this.selectedListIndex = i;
        //  alert(this.listMenu[i].action)

        this.navigateTo(this.listMenu[i].action);
        this.menus = [];
        this.subMenus = [];
        this.appService.setSelectedQueueName('Manager Console');
      }
    }
    this.selectedListMenu = structuredClone(this.listMenu);
    // if (this.listMenu[i].label != 'Queue') {
    this.router.navigateByUrl('/' + this.listMenu[i].action);
    // }
  }

  selectMenu(j: number, selectedQueueName: string) {
    // console.log('MenuComponent selectMenu');
    // if(selectedQueueName){
    //   this.filteredQueueSections?.forEach((item, index) => {
    //    if (item.label == selectedQueueName){
    //       j = index;
    //    }
    //  });
    // }
    // console.log('selectMenu', j);
    this.selectedMenuIndex = j;
    this.selectedSubMenuIndex = null;
    this.clearSelectedMenus();

    // Explicitly deselect all queue submenus so switching between them
    // (e.g., Outbound → Email) doesn't leave the old one highlighted.
    // clearSelectedMenus() intentionally skips these when !IsMainMenuClicked,
    // but a direct submenu click must always clear the previous selection.
    this.listMenu[this.selectedListIndex]?.children?.forEach((child: any) => {
      child.isselected = false;
    });



    if (this.filteredQueueSections.length != 1) {
      this.listMenu[this.selectedListIndex].isselected = true;
      this.IsDisablemenu = false;
    } else {
      this.listMenu[this.selectedListIndex].isselected = false;
      this.IsDisablemenu = true
    }
    if (this.listMenu[this.selectedListIndex].children.length > 0) {

      this.menus = this.listMenu[this.selectedListIndex].children;
      var isBlendedAvailable = this.menus.find(user => user.label === 'Blended');
      var isOutboundAvailable = this.menus.find(user => user.label === 'Outbound');
      if (isBlendedAvailable) {
        this.menus.splice(0, 1)
        this.tmQueueService.setisBlendedQueueAvailable(true);
      }
      else {
        this.tmQueueService.setisBlendedQueueAvailable(false);
      }
      //if (!isOutboundAvailable) {
      //    var Outboundqueue =
      //        { action: 'Outbound', label: 'Outbound', isselected: false, isdisabled: false, children: [] };

      //    this.menus.splice(1, 0, Outboundqueue);
      //    //this.menus[1] = Outboundqueue;
      //}

      if (this.menus.length == 1)
        {
        this.selectedMenuIndex = 0;
        }
       else if (this.menus.length == 2)
        {
        this.selectedMenuIndex = this.selectedMenuIndex;
        }
      else
      {
        this.selectedMenuIndex = j;
      }
      // Fix menu index selection — runs after the length-based fallback so the
      // correct submenu is always highlighted when a name is explicitly provided.
      if (selectedQueueName) {
        const correctedIndex = this.menus.findIndex((item: any) => item.label === selectedQueueName);
        this.selectedMenuIndex = correctedIndex !== -1 ? correctedIndex : 0;
      }
      if (this.selectedListIndex == 0) {
        this.queueService.notifyOther({
          refresh: true,
          menuName: this.menus[this.selectedMenuIndex]?.label,
        });
      }
      if (this.menus[this.selectedMenuIndex].children && this.menus[this.selectedMenuIndex].children.length > 0) {
        this.selectSubMenu(0);
        //  this.subMenus = this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].children;
      } else {
        // alert(this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].action)
        this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].isselected = true;
        this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].isdisabled = false;
        const menuName = this.menus[this.selectedMenuIndex].label;
        if ((menuName === 'Inbound' || menuName === 'Outbound' || menuName === 'Search' || menuName === 'Email') && !this.IsMainMenuClicked) {
          // this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].isselected = false;

          //New code 
          const list = this.listMenu.filter(i=>i.label == 'Queue');
          console.log(list);
          if(list[0].label == 'Queue'){
            if (list[0].children && list[0].children.length > 0) {
              this.appService.selectedQueueType.subscribe((data: any) => {
                console.log(data)
                this.queueType = data;
              });
          
              let menu = list[0].children.filter(i=>i.label ==  this.queueType );
              let otherMenu = list[0].children.filter(i=>i.label !=  this.queueType );
              if(menu  && menu.length > 0){
                if(!this.IsMainMenuClicked){
                  menu[0].isselected = true;
                 
                }
              }
              if(otherMenu  && otherMenu.length > 0){
                if(!this.IsMainMenuClicked){
                  otherMenu.forEach(element => {
                    element.isselected = false;
                  });
                 
                }
              }

                }
              }    

          this.isButtonDisable = true
          this.queueService.setTaskMenuAccordian(menuName);
          this.doOnInit(false);
          //loader

        } else {
          this.navigateTo(this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].action);
        }

        this.selectedSubMenuIndex = null;
        this.subMenus = [];
      }
    } else {
      this.selectedMenuIndex = null;
      this.selectedSubMenuIndex = null;
      this.menus = [];
      this.subMenus = [];
    }
    this.selectedListMenu = structuredClone(this.listMenu);
    this.dialerService.setPhoneNo('');
    this.dialerService.setResetCallSummary(true);
  }

  selectSubMenu(k: number) {
    this.IsMainMenuClicked = false;
    // console.log('MenuComponent selectSubMenu');
    // console.log('selectSubMenu', k);
    this.selectedSubMenuIndex = k;
    this.clearSelectedMenus();
    this.listMenu[this.selectedListIndex].isselected = true;
    this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].isselected = true;
    this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].children[k].isselected = true;

    this.menus = this.listMenu[this.selectedListIndex].children;
    this.subMenus = this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].children;
    // console.log(this.listMenu);
    // console.log(this.selectedListIndex);
    // console.log(this.selectedMenuIndex);
    // console.log(k);
    this.navigateTo(this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].children[k].action);
    this.selectedListMenu = structuredClone(this.listMenu);
  }

  showMenus(link: any) {
    // console.log('MenuComponent showMenus');
    this.menus = link.children;
    this.subMenus = [];
  }

  showSubMenus(link: any) {
    // console.log('MenuComponent showSubMenus');
    this.subMenus = link.children;
  }

  showSelected() {
    //console.log('MenuComponent showSelected');
    if (this.selectedListMenu.length > 0) {
      this.selectedListMenu.forEach((link: any) => {
        if (link.isselected) {
          if (link.children && link.children.length > 0) {
            this.menus = link.children;
            link.children.forEach((menu: any) => {
              if (menu.isselected) {
                if (menu.children && menu.children.length > 0) {
                  this.subMenus = menu.children;
                }
              }
            });
          }
        }
      });
    } else {
      this.menus = [];
      this.subMenus = [];
    }
  }

  navigateTo(action: any) {
    // console.log('MenuComponent navigateTo');
    const listmenu =
      this.selectedListIndex != null && this.selectedListIndex >= 0 ? this.listMenu[this.selectedListIndex].action : '';
    const menu =
      this.selectedListIndex != null &&
        this.selectedListIndex >= 0 &&
        this.selectedMenuIndex != null &&
        this.selectedMenuIndex >= 0
        ? this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].action
        : '';
    const submenu =
      this.selectedListIndex != null &&
        this.selectedListIndex >= 0 &&
        this.selectedMenuIndex != null &&
        this.selectedMenuIndex >= 0 &&
        this.selectedSubMenuIndex != null &&
        this.selectedSubMenuIndex >= 0
        ? this.listMenu[this.selectedListIndex].children[this.selectedMenuIndex].children[this.selectedSubMenuIndex]
          .action
        : '';
    let name = '';
    if (listmenu != '') {
      name = listmenu;
    }
    if (menu != '') {
      name = menu;
    }
    if (submenu != '') {
      name = submenu;
    }
    const curMenu = {
      listmenu: listmenu,
      menu: menu,
      submenu: submenu,
      name: name,
      action: (listmenu != '' ? listmenu : '') + (menu != '' ? '/' + menu : '') + (submenu != '' ? '/' + submenu : ''),
    };
    // console.log('curMenu', curMenu);
    //if (!this.tmQueueService.getisTopMenuQueueSelected()) {
    this.appService.setCurrentMenu(curMenu);
    //}
    this.HeaderComponent.changeUserStatusHeader();
  }

  async checkAuditSurveyExperience() {
    // console.log('MenuComponent checkAuditSurveyExperience');
    const data: any = await lastValueFrom(this.consoleService.hasAuditSurveyExperience());
    const isValid = ResponseHandler.processResponse(data, 'hasAuditSurveyExperience');
    if (isValid) {
      this.hasAuditSurvey = data.Response.Data;
    }
    // console.log(this.hasAuditSurvey, 'status');
  }

  doOnInit(closeable: boolean = false) {
    // console.log('Queue component loaded');
    this.tmQueueService.setisQueueTaskMenuLoaded(true);
    this.appService.currentMenu.subscribe((val: boolean) => {
      if (val) {
        if (this.tmQueueService.getisTopMenuQueueSelected()) {
          this.tmQueueService.setisTopMenuQueueSelected(false);
        } else {
          //console.log('Queue component appService.currentMenu subscribe:' + val);
          //this.currentMenu = val;
          //console.log('this.currentMenu', this.currentMenu);
          //if (this.currentMenu?.listmenu != '') {
          //    this.currentpath = this.currentMenu.listmenu;
          //}
          //if (this.currentMenu?.menu != '') {
          //    this.currentpath = this.currentpath + ' > ' + this.currentMenu.menu;
          //}
          //if (this.currentMenu?.submenu != '') {
          //    this.currentpath = this.currentpath + ' > ' + this.currentMenu.submenu;
          //}
          ////if (this.action != '') {
          //this.action = this.currentMenu?.action;
          //if (!this.tmQueueService.getisTopMenuQueueSelected()) {
          //    this.loadActionTable(this.action);
          //}
          //}
        }
      }
    });
    this.appService.startUserHeartbeat();
    this.appService.setUserLoggedout(false);
    this.appService.getUser();
    //this.getUserId = setInterval(() => {
    //    this.appService.getUser();
    //}, 5000);

    this.getQueues(closeable);

    //this.setUserStatus(6, null);
    //this.getVoicemailCountByStatus(-1, 'new');
  }

  getQueues(closeable: boolean = false) {
    this.tmQueueService
      .getQueues()
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'getQueues');

          if (isValid) {
            
            this.isAuditor = this.securityService.validateGrant('AuditAgents');
            this.isManager = this.securityService.validateGrant('ManageAgents');
            this.isStaffer = this.securityService.validateGrant('ManageAssignments');
            this.isReporter = this.securityService.validateGrant('Reporting');

            // console.log(this.router.url);
            // if (localStorage.getItem('pageRefreshed') === 'true') {
            //   // if (!(this.router.url.indexOf('Inbound') == -1 && this.router.url.indexOf('Outbound') == -1)) {
            //   //   // this.openTaskSelectionMenuModal(data.Response.Data, closeable);
            //   // } else {
            //   localStorage.removeItem('pageRefreshed');
            //   // localStorage.removeItem('selectedQueue');
            //   // }
            // } else {this.isTM && !(this.isAuditor || this.isManager || this.isStaffer)
            // this.isAuditor = this.securityService.validateGrant('AuditAgents');
            // this.isManager = this.securityService.validateGrant('ManageAgents');
            // this.isIVRManager = this.securityService.validateGrant('ManageIVR');
            // this.isStaffer = this.securityService.validateGrant('ManageAssignments');
            // this.isCampaigner = this.securityService.validateGrant('ManageCampaigns');
            // this.isTM = this.securityService.validateGrant('TM');
            // this.isSoftphoneOnly = this.securityService.validateGrant('SoftphoneOnly');
            // this.isTwilio = this.securityService.validateGrant('Twilio');
            if (data.Response.Data.length == 1 && !(this.isAuditor || this.isManager || this.isStaffer)) {
              let q = data.Response.Data[0]
              let queueItem = {
                id: q.ID,
                type: q.Type,
                dialertype: q.DialerType,
                name: q.Name,
                items: q.Items,
                // countLabel: countLabel,
                queue: q,
                };
                if (localStorage.getItem('pageRefreshed') === 'true') {
                    localStorage.removeItem('pageRefreshed');
                }
              this.mainController.initializeSoftPhone();
              this.goToQueue(queueItem)
            } else if (this.filteredQueueSections.length == 0 && this.isTM && (this.isAuditor || this.isManager || this.isStaffer)) {
              // this.listMenu = this.listMenu.filter(
              //   item => item.label === 'Console' || item.label === 'Performance'
              // );
              this.mainController.setAllDialerWindowStatus(false, false, false);
              this.queueService.setQueueRoute(this.clientAbbreviation + '/Console/Queues');
              this.appService.setUserStatus(12, null);
              // this.closeTaskSelectionMenu();
                this.mainController.initializeSoftPhone();
              this.router.navigate([this.clientAbbreviation + '/Console/Queues']);
              const currMenu = {
                listmenu: this.clientAbbreviation + '/Console',
                menu: 'Queues',
                submenu: '',
                name: 'Queues',
                action: this.clientAbbreviation + '/Console/Queues',
              };
              this.appService.setCurrentMenu(currMenu);
              this.HeaderComponent.changeUserStatusHeader();
              // this.selectLink(0);
            }
            else {
              this.openTaskSelectionMenuModal(data.Response.Data, closeable);
            }


            // }
          }
        }),
        catchError(error => {
          console.log(error);
          this.IsDisablemenu = false;
          return EMPTY;
        })
      )
      .subscribe();
  }

  openTaskSelectionMenuModal(queueList: any, closeable: boolean = false) {
    // console.log(this.router.url.split['/'])
    const splitted = this.router.url.split('/');
    //let closeable: boolean = false;
    //  if (splitted.length > 2) closeable = true;
    const initialState = {
      queueList: queueList,
      isAuditor: this.isAuditor,
      isManager: this.isManager,
      isStaffer: this.isStaffer,
      isReporter: this.isReporter,
      isCloseable: closeable,
      isTM: this.isTM,
      isSoftphoneOnly: this.isSoftphoneOnly,
      isTwilio: this.isTwilio,
    };

    let config: ModalOptions = {};
    if (closeable) config = { class: 'task-menu', backdrop: 'static', keyboard: false, initialState };
    else config = { class: 'task-menu', backdrop: 'static', keyboard: false, initialState };

    this.modalRef = this.modalService.show(TaskMenuComponent, config);
    this.modalRef.content.taskmenuLoaded.subscribe(res => {
      if (res) {
        this.IsDisablemenu = false;
        //loader
        this.isButtonDisable = false;
      }
    });
    //this.modalRef.content.event.subscribe((result: any) => {
    //  this.loadQueue(result);

    //  /* if (result == 'OK') {
    //     this.getPosts();
    //   }*/
    //  //code to redirect
    //  alert('redirect');
    //});
  }

  // queueItem = {
  //   id: q.ID,
  //   type: q.Type,
  //   dialertype: q.DialerType,
  //   name: q.Name,
  //   items: q.Items,
  //   countLabel: countLabel,
  //   queue: q,
  // };


  // goToQueue(selectedQueue: any) {
  //   // this.event.emit({selectedQueue});
  //     this.queueService.setQueueRoute('');
  //     this.mainController.setAllDialerWindowStatus(false, false, false);
  //   localStorage.setItem('qid', selectedQueue.ID);
  //   localStorage.setItem('selectedQueue', JSON.stringify(selectedQueue));
  //   this.queueService.setselectedQueueId(selectedQueue.ID);
  //   this.queueService.notifyOtherFromTaskMenu({
  //     refresh: true,
  //     menuName: selectedQueue.type,
  //   });
  //   this.queueService.SetTaskSelectedQueue({
  //     refresh: true,
  //     menuName: selectedQueue,
  //   });
  //   this.queueService.setIsPageLoadCompleted(false);
  //   //this.tmQueueService.setisCallConnected(false);
  //   this.queueService.setTaskMenuQueueSelected({
  //     pageRefresh: true,
  //     isPageInitCompleted: false,
  //     queueType: selectedQueue.Type,
  //   });
  //   //  this.queueService.setTaskMenuQueueSelected(true);
  //   console.log('selectedQueue', selectedQueue);
  //   //this.router.navigateByUrl(this.clientAbbreviation + '/Queue/'+ selectedQueue.type +"?qid="+ selectedQueue.id );
  //   this.HeaderComponent.getInboundCallStats(selectedQueue.ID);
  //   this.appService.setselectedQueueId(selectedQueue.ID);
  //   this.appService.setSelectedQueueName(selectedQueue.Name);
  //   this.appService.setSelectedQueueType(selectedQueue.Type);
  //   this.appService.setActivityId(selectedQueue.ActivityID);
  //   this.getQueueInfo(selectedQueue.Id);

  //   const url = this.configService.geturl(this.clientAbbreviation);
  //   if (url) {
  //     this.configService.OpenUrlInNewTab(url);
  //   }
  //   this.queueService.setQueueRoute(
  //     this.clientAbbreviation + '/Queue/' + selectedQueue.Type + '?qid=' + selectedQueue.Id
  //   );
  //   this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.Type], {
  //     queryParams: { qid: selectedQueue.Id },
  //   });
  // }

  goToQueue(selectedQueue: any) {
    // this.event.emit({selectedQueue});
    this.queueService.setQueueRoute('');
    this.mainController.setAllDialerWindowStatus(false, false, false);
    localStorage.setItem('qid', selectedQueue.id);
    localStorage.setItem('selectedQueue', JSON.stringify(selectedQueue));
    this.queueService.setselectedQueueId(selectedQueue.id);
    this.queueService.notifyOtherFromTaskMenu({
      refresh: true,
      menuName: selectedQueue.type,
    });
    this.queueService.SetTaskSelectedQueue({
      refresh: true,
      menuName: selectedQueue,
    });
    this.queueService.setIsPageLoadCompleted(false);
    //this.tmQueueService.setisCallConnected(false);
    this.queueService.setTaskMenuQueueSelected({
      pageRefresh: true,
      isPageInitCompleted: false,
      queueType: selectedQueue.queue.Type,
    });
    //  this.queueService.setTaskMenuQueueSelected(true);
    // this.closeTaskSelectionMenu();
    //console.log('selectedQueue', selectedQueue);
    //this.router.navigateByUrl(this.clientAbbreviation + '/Queue/'+ selectedQueue.type +"?qid="+ selectedQueue.id );
    this.HeaderComponent.getInboundCallStats(selectedQueue.id);
    this.appService.setselectedQueueId(selectedQueue.id);
    this.appService.setSelectedQueueName(selectedQueue.name);
    this.appService.setSelectedQueueType(selectedQueue.type);
    this.appService.setActivityId(selectedQueue.queue.ActivityID);
    this.getQueueInfo(selectedQueue.id);

    const url = this.configService.geturl(this.clientAbbreviation);
    if (url) {
      this.configService.OpenUrlInNewTab(url);
    }
    this.queueService.setQueueRoute(
      this.clientAbbreviation + '/Queue/' + selectedQueue.type + '?qid=' + selectedQueue.id
    );
    
    this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type], {
      queryParams: { qid: selectedQueue.id },
    }).then(() => {
      this.isButtonDisable = false;
    });
    
    // this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type], {
    //   queryParams: { qid: selectedQueue.id },
    // });
  }

  getQueueInfo(queueId: any) {
    this.tmQueueService.getQueueInfo(queueId).subscribe(data => {
      // console.log("getQueueInfo response", data);

      this.QueueInfoDetail = data.Response.Data;
      this.appService.SetQueueInfo(this.QueueInfoDetail);
    });
  }

  getShowDialerStatus(): any {
    return this.mainController.getShowDialerWindowStatus();
  }

  getSpeedClass(): 'poor' | 'good' | 'excellent' | 'unknown' {
    const speed = parseFloat(this.internetSpeed);
    if (isNaN(speed)) return 'unknown';
    if (speed < 10) return 'poor';
    if (speed < 50) return 'good';
    return 'excellent';
  }
}
